import { render, staticRenderFns } from "./PatDetailExtranet.vue?vue&type=template&id=3845dc4b&scoped=true"
import script from "./PatDetailExtranet.vue?vue&type=script&lang=js"
export * from "./PatDetailExtranet.vue?vue&type=script&lang=js"
import style0 from "./PatDetailExtranet.vue?vue&type=style&index=0&id=3845dc4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845dc4b",
  null
  
)

export default component.exports